export const T = {
  en_GB: {
    account: "Account",
    portfolios: "Portfolios",
    startCash: "Start cash",
    netPortfolios: "Net portfolios",
    internalTransfers: "Internal transfers",
    depositNeeded: "Deposit needed",
    cashLeft: "Cash left",
    cashLeftHint: "Cash left assumes the deposit needed is made.",
    balancesAsOf: (date: string) => `Bank balances as of ${date} · Planned effects are estimates`,
    balancesNeverSynced: "Planned effects are estimates",
    noAccounts: "The client has no accounts yet.",
  },
  nb_NO: {
    account: "Konto",
    portfolios: "Porteføljer",
    startCash: "Startkontanter",
    netPortfolios: "Netto porteføljer",
    internalTransfers: "Interne overføringer",
    depositNeeded: "Nødvendig innskudd",
    cashLeft: "Gjenværende kontanter",
    cashLeftHint: "Gjenværende kontanter forutsetter at nødvendig innskudd gjøres.",
    balancesAsOf: (date: string) => `Banksaldoer per ${date} · Planlagte effekter er estimater`,
    balancesNeverSynced: "Planlagte effekter er estimater",
    noAccounts: "Kunden har ingen kontoer ennå.",
  },
} as const;
